import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { CloudinaryResource, fetchImagesByTag, getThumbnailUrl, getFullSizeUrl } from '../utils/cloudinary';

const Home: React.FC = () => {
  const [travelImages, setTravelImages] = useState<CloudinaryResource[]>([]);
  const [flyingImages, setFlyingImages] = useState<CloudinaryResource[]>([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState<string[]>([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  useEffect(() => {
    const fetchImages = async () => {
      const [travel, flying] = await Promise.all([
        fetchImagesByTag('travel', 8),
        fetchImagesByTag('flying', 8)
      ]);
      setTravelImages(travel);
      setFlyingImages(flying);
    };
    fetchImages();
  }, []);

  const openLightbox = (images: string[], index: number) => {
    setLightboxImages(images);
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  return (
    <>
      <div className="text-justify">
        <br />
        <h3>Hi, I'm Alex!</h3>
        <br />
        <p>
          I'm the founder of <a href="https://www.balances.ai">Balances.ai</a>, a beautiful, modern, AI-native accounting platform for small businesses.
        </p>
        <p>
          Before that, I headed up the product management team at <a href="https://pilot.com">Pilot.com</a>, in San Francisco.
          I'm an instrument-rated pilot and spend my spare time exploring California in a Cirrus SR22.
        </p>
        <p>
          Before Pilot.com, I worked at <a href="https://xero.com">Xero</a>, where I led product for Xero's AI bookkeeping initiatives. Before that, I worked on international expansion and helped set up Xero in Asia.
        </p>
        <p>
          In the middle of all that, I took <Link to="/travel">a long break</Link>, which had me travelling, taking photos, and learning to fly small airplanes.
        </p>
        <p>
          I'm working on a <a href="https://www.airborn.co">fun open-source side project</a> with the mission of making it easier for pilots to calculate how much runway they need to take off and land (Github repo <a href="https://github.com/alexjcampbell/Airborn/">here</a>).
        </p>
        <p>
          If you're interested in airplanes, software development, or automating bookkeeping for small businesses and want to chat, feel free to reach out to me at alex j campbell AT gmail dot com, or you can find out more about me <Link to="/about_alex">here</Link>. I'm also on <a href="https://www.linkedin.com/in/alexjcampbell">LinkedIn</a>, <a href="https://twitter.com/alexjcampbell">Twitter</a>, and <a href="https://instagram.com/alexjcampbell">Instagram</a>.
        </p>
      </div>
      <br />
      <div className="text-justify">
        <br />
        <h3>What's new</h3>
        <ul>
          <li><Link to="/flyinginnz">Flying a small airplane around New Zealand - tips and an itinerary</Link></li>
        </ul>
      </div>

      <div className="row">
        <style>{`
          div.imagetiles div.col-lg-3.col-md-3.col-sm-3.col-xs-6 {
            padding: 10px;
          }
        `}</style>

        <div className="col-md-12">
          <div className="container">
            <div className="row imagetiles">
              {travelImages.map((image, index) => (
                <div key={`travel-${index}`} className="col-lg-3 col-md-3 col-sm-3 col-xs-6" id="links">
                  <a
                    href={getFullSizeUrl(image.public_id)}
                    data-lightbox="gallery"
                    onClick={(e) => {
                      e.preventDefault();
                      const allImages = [
                        ...travelImages.map(img => getFullSizeUrl(img.public_id)),
                        ...flyingImages.map(img => getFullSizeUrl(img.public_id))
                      ];
                      openLightbox(allImages, index);
                    }}
                  >
                    <img
                      src={getThumbnailUrl(image.public_id)}
                      alt={`Travel ${index + 1}`}
                    />
                  </a>
                </div>
              ))}

              {flyingImages.map((image, index) => (
                <div key={`flying-${index}`} className="col-lg-3 col-md-3 col-sm-3 col-xs-6" id="links">
                  <a
                    href={getFullSizeUrl(image.public_id)}
                    data-lightbox="gallery"
                    onClick={(e) => {
                      e.preventDefault();
                      const allImages = [
                        ...travelImages.map(img => getFullSizeUrl(img.public_id)),
                        ...flyingImages.map(img => getFullSizeUrl(img.public_id))
                      ];
                      openLightbox(allImages, travelImages.length + index);
                    }}
                  >
                    <img
                      src={getThumbnailUrl(image.public_id)}
                      alt={`Flying ${index + 1}`}
                    />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={lightboxImages.map(src => ({ src }))}
        index={lightboxIndex}
      />
    </>
  );
};

export default Home;
